module.exports = "div:nth-child(2n) {\n  margin: 30px 0; }\n\n.header p {\n  margin: 0 0 10px 10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/consignment/order-summary/order-summary.component.scss
// module id = ./src/app/modules/consignment/order-summary/order-summary.component.scss
// module chunks = main